// Order types
export type OrderType = 'mesa' | 'llevar' | 'encargo';
export type OrderStatus = 'pendiente' | 'preparando' | 'en_almacen' | 'completado' | 'cancelado' | 'esperando_pago';
export type PaymentMethod = 'online' | 'local';
export type PaymentStatus = 'pendiente' | 'pagado' | 'pago_en_tienda';

export interface CartItem {
  id: string;
  name: string;
  category: string;
  price: number; // Total price including extras
  quantity: number;
  removedIngredients?: string[]; // Legacy for Carta products
  selectedExtras?: SelectedCustomization[]; // New for Encargos with prices
  basePrice?: number; // Original price before extras
}

// Customization option with optional price (for extras)
export interface CustomizationOption {
  id: string;
  label: string;
  price: number; // 0 for free modifications, >0 for paid extras
}

// Group of customization options
export interface CustomizationGroup {
  id: string;
  title: string;
  required: boolean;
  type: 'checkbox' | 'radio';
  options: CustomizationOption[];
}

// Selected customization saved in cart
export interface SelectedCustomization {
  groupId: string;
  groupTitle: string;
  optionId: string;
  optionLabel: string;
  price: number;
}

// Product definition with customization options
export interface ProductDefinition {
  id: string;
  name: string;
  price: number;
  category: string;
  subcategory?: string;
  description?: string;
  tags?: ("sin-lactosa" | "vegetariano" | "con-lactosa")[];
  removableIngredients?: string[]; // Legacy for Carta products
  customizationGroups?: CustomizationGroup[]; // New for Encargos
}

export interface Order {
  id: string;
  order_number: number;
  order_type: OrderType;
  status: OrderStatus;
  payment_method: PaymentMethod;
  payment_status: PaymentStatus;
  table_number?: number;
  customer_name?: string;
  customer_phone?: string;
  customer_email?: string;
  pickup_date?: string;
  pickup_time?: string;
  pickup_location?: string;
  observations?: string;
  stripe_session_id?: string;
  location_id?: string;
  subtotal: number;
  total: number;
  created_at: string;
  updated_at: string;
  items?: OrderItem[];
  // Cash payment tracking (POS/TPV)
  cash_received?: number;
  change_returned?: number;
  // Staff traceability
  served_by?: string;
  // Invoice series (M=Mesa, L=Llevar, E=Encargo)
  ticket_series?: string;
  series_number?: number;
}

export interface OrderItem {
  id: string;
  order_id: string;
  product_name: string;
  product_category?: string;
  unit_price: number;
  quantity: number;
  subtotal: number;
  created_at: string;
}

export interface Location {
  id: string;
  code: string;
  name: string;
  address: string;
  phone: string;
}

// Location codes for URL parameters (QR codes)
export const LOCATION_CODES: Record<string, string> = {
  "siete-palmas": "Siete Palmas",
  "lomo-frailes": "Lomo Los Frailes",
  // Legacy codes for backward compatibility with existing QRs
  "felo-monzon": "Siete Palmas",
  "jordan": "Lomo Los Frailes",
};

export const LOCATIONS: Location[] = [
  {
    id: "siete-palmas",
    code: "siete-palmas",
    name: "Siete Palmas",
    address: "Av. Pintor Felo Monzón, 2, 35019 – Las Palmas de Gran Canaria",
    phone: "928 13 71 95"
  },
  {
    id: "lomo-frailes",
    code: "lomo-frailes",
    name: "Lomo Los Frailes",
    address: "C/ Jordán, 42, 35018 – Las Palmas de Gran Canaria",
    phone: "928 66 59 67"
  },
];
